export default __webpack_public_path__ + "static/Cactus_Broth-0e6cd88b41b7de498db690547490cbc8.png";